import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function SolidTrianglePointerIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 29 13">
    <path fill="currentColor" d="M14.2896 0L28.579 12.75H0.000131607L14.2896 0Z"/>
  </SvgIcon>
}

export default SolidTrianglePointerIcon
